import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
//import { fetchLedgerDetail } from './API'
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { fetchReferenceMaster } from "./API";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import CtART from "./CustomTool/ResponsiveTable";

class ReferenceMaster extends Component {
  state = {
    columnsdata: [
      { accessorKey: "bint_srno", header: "SR NO", hide: true },
      { accessorKey: "vac_referencename", header: "Reference Person Name" },
      { accessorKey: "vac_mobileno", header: "Mobile No." },
      {
        accessorKey: "dec_percentageonsalesamount",
        header: "% on Sales Amount",
        hide: true,
      },
    ],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "bint_srno", label: "SR NO", hide: true },
      { id: "vac_referencename", label: "Reference Person Name" },
      { id: "vac_mobileno", label: "Mobile No." },
      {
        id: "dec_percentageonsalesamount",
        label: "% on Sales Amount",
        hide: true,
      },
    ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "ReferenceMaster:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "ReferenceMaster:",
        actionType: "AlertResponsive",
      },
    ],
    keyColumn: [
      "bint_srno",
      "vac_referencename",
      "vac_mobileno",
      "dec_percentageonsalesamount",
    ],
    formData: {
      bint_acid: "",
      EditReferenceMasterSrNo: "",
      txtRefePersonName: "",
      txtMobileNo: "",
      txtSalesAmt: "",
    },
    searchData: {
      vac_referencename: "",
      vac_mobileno: "",
      dec_percentageonsalesamount: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    {
      !this.props.showHeading &&
        (document.title = "RiTe Account : Reference Master");
    }
    this.props.setActiveMenu("ReferenceMaster");
    this.setSearchColumns();
    this.ShortCut();
    this.props.verifyUserID(
      this.getInfo,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
    // this.getInfo();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchInputChangeTrim = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value.trim(),
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row, index) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_referencename.length === 0 ||
            (row["vac_referencename"] &&
              row["vac_referencename"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_referencename.toLowerCase()
                ))) &&
          (this.state.searchData.vac_mobileno === "" ||
            (row["vac_mobileno"] &&
              row["vac_mobileno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_mobileno.toLowerCase()))) &&
          (this.state.searchData.dec_percentageonsalesamount === "" ||
            (row["dec_percentageonsalesamount"] &&
              row["dec_percentageonsalesamount"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dec_percentageonsalesamount.toLowerCase()
                )))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState({
        searchOpen,
        searchRows,
        searchRowsCount,
        counter: this.state.counter + 1,
      });
    } else {
      this.setState({ searchOpen });
    }
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleARDonActionClick = (row) => {
    const EditReferenceMasterSrNo = row.bint_srno,
      txtRefePersonName = row.vac_referencename,
      txtMobileNo = row.vac_mobileno,
      txtSalesAmt = row.dec_percentageonsalesamount,
      actionName = row.actionName;
    if (actionName == "Edit") {
      this.setState({
        formData: {
          ...this.state.formData,
          EditReferenceMasterSrNo,
          txtRefePersonName,
          txtMobileNo,
          txtSalesAmt,
        },
      });
    } else if (actionName == "Delete") {
      this.DeleteData(EditReferenceMasterSrNo, txtRefePersonName);
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_referencename"]);
    const EditReferenceMasterSrNo = row.bint_srno,
      txtRefePersonName = row.vac_referencename;
    this.DeleteData(EditReferenceMasterSrNo, txtRefePersonName);
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_srno",
      "vac_referencename",
      "vac_mobileno",
      "dec_percentageonsalesamount",
    ]);
    const EditReferenceMasterSrNo = row.bint_srno,
      txtRefePersonName = row.vac_referencename,
      txtMobileNo = row.vac_mobileno,
      txtSalesAmt = row.dec_percentageonsalesamount;

    this.setState({
      formData: {
        ...this.state.formData,
        EditReferenceMasterSrNo,
        txtRefePersonName,
        txtMobileNo,
        txtSalesAmt,
      },
    });
  };

  //#endregion handle

  //#region function

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      {
        handleOnclickSave: this.SaveReferenceMaster,
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: () => {
          this.DeleteData(
            this.state.formData.EditReferenceMasterSrNo,
            this.state.formData.txtRefePersonName
          );
        },
      }

      // this.saveSales(true)
    );
  };

  validatReferenceMaster = () => {
    let result = false;
    if (this.state.formData.txtRefePersonName.length <= 0) {
      this.props.toastErrorMsg(
        "Enter Reference Person Name",
        "txtRefePersonName"
      );
    } else if (
      this.state.formData.txtMobileNo.length != 0 &&
      this.state.formData.txtMobileNo.length < 10
    ) {
      this.props.toastErrorMsg("Enter 10 igit Mobile Number", "txtMobileNo");
    } else {
      result = true;
    }
    return result;
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      { cType: "Lbl", id: "bint_ledgergroupidsrno" },
      {
        cType: "CtTxt",
        id: "vac_referencename",
        label: "Reference Person Name",
        value: this.state.searchData.vac_referencename,
        handleOnChange: this.handleOnSearchInputChange,
        width: "220",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_mobileno",
        label: "Mobile No.",
        value: this.state.searchData.vac_mobileno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "130",
      },
      {
        cType: "CtTxt",
        id: "dec_percentageonsalesamount",
        label: "% on Sales Amount",
        value: this.state.searchData.dec_percentageonsalesamount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "220",
      }
    );
    this.setState({ searchColumns });
  };

  getInfo = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadReference",
        bint_acid: localStorage.getItem("acid"),
      };
      fetchReferenceMaster(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          if (res.data.ReferenceList && res.data.ReferenceList.length > 0) {
            rows = res.data.ReferenceList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              dataLoadStatus,
              rows,
              rowsCount,
            }
            // () => {
            //     if (this.props.refreshGroupNameList) {
            //         this.props.refreshGroupNameList(rows);
            //     }
            // }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtRefePersonName").focus();
  };

  DeleteData = (EditReferenceMasterSrNo, StrReferenceMaster) => {
    if (EditReferenceMasterSrNo > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Reference Name : " +
              StrReferenceMaster +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteReference(EditReferenceMasterSrNo);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  SaveReferenceMaster = () => {
    if (this.validatReferenceMaster()) {
      let dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "SaveReference",
          bint_acid: localStorage.getItem("acid"),
          bint_srno: this.state.formData.EditReferenceMasterSrNo,
          // edit_referenceidsrno: this.state.formData.EditReferenceMasterSrNo,
          vac_referencename: this.state.formData.txtRefePersonName,
          vac_mobileno: this.state.formData.txtMobileNo,
          dec_percentageonsalesamount: this.state.formData.txtSalesAmt,
        };
        fetchReferenceMaster(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              dataLoadStatus = true;
              let rows = [],
                rowsCount = 0;
              if (res.data.ReferenceList && res.data.ReferenceList.length > 0) {
                rows = res.data.ReferenceList;
                rowsCount = rows.length;
              }
              this.setState(
                {
                  dataLoadStatus,
                  rows,
                  rowsCount,
                },
                () => {
                  this.props.updateRefenceitemList &&
                    this.props.updateRefenceitemList(res.data.ReferenceList);
                }
              );
              this.clearInfo(true);
            } else {
              this.setState({
                dataLoadStatus: true,
              });
            }
          })
          .catch((error) => {
            console.log(
              "Unknown error occurred in SaveReferenceMaster.",
              error
            );
          });
      });
    }
  };

  clearInfo = () => {
    const bint_acid = "",
      EditReferenceMasterSrNo = "",
      txtRefePersonName = "",
      txtMobileNo = "",
      txtSalesAmt = "";

    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_acid,
          EditReferenceMasterSrNo,
          txtRefePersonName,
          txtMobileNo,
          txtSalesAmt,
        },
      },
      () => {
        document.getElementById("txtRefePersonName").focus();
      }
    );
  };

  DeleteReference = (EditReferenceMasterSrNo) => {
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus: false }, () => {
      const reqData = {
        Op: "DeleteReference",
        bint_acid: localStorage.getItem("acid"),
        bint_srno: EditReferenceMasterSrNo,
      };
      fetchReferenceMaster(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState({ ARD: null }, () => {
              this.getInfo();
              this.clearInfo(true);
            });
          } else {
            this.setState({ dataLoadStatus: true });
          }
        })
        .catch((error) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in LedgerGroup. " + error
          );
        });
    });
    return false;
  };
  //#endregion handle

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {this.props.showHeading == true && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "30px", color: "#515151" }}
            >
              <b>Reference Master</b>
            </label>
          </Grid>
        )}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtRefePersonName"
                  value={this.state.formData.txtRefePersonName}
                  label="Reference Person Name*"
                  handleOnChange={this.handleOnChange}
                  width={220}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtMobileNo"
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtMobileNo"
                  value={this.state.formData.txtMobileNo}
                  label="Mobile No."
                  handleOnChange={this.handleOnChange}
                  width={170}
                  style={{}}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  defaultAction={() => {
                    this.trimFormData(() => {
                      this.SaveReferenceMaster();
                    });
                  }}
                />
              </Grid>
              {/* <Grid item>
                                <CtTxtAmt
                                    id="txtSalesAmt"
                                    value={this.state.formData.txtSalesAmt}
                                    label="% on Sales Amount"
                                    handleOnChange={this.handleOnChange}
                                    width={170}
                                    maxLength={10}
                                    onKeyDown={this.props.onKeyDown}
                                    nextCtrlID=""
                                />
                            </Grid> */}
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtBtn
                  id={"SaveReference"}
                  label="Save"
                  onClick={() => {
                    this.trimFormData(() => {
                      this.SaveReferenceMaster();
                    });
                  }}
                />
              </Grid>
              <Grid item>
                <CtBtn label="New" onClick={this.clearInfo} variant="outlined"/>
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.EditReferenceMasterSrNo,
                      this.state.formData.txtRefePersonName
                    );
                  }}
                />
              </Grid>
              {/* <Grid item>
                                <CtBtn label="Close"/>
                            </Grid> */}
            </Grid>
          </Grid>
        </Grid>
        <br />
        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          // toolTipNewEntry='New Product Entry'
        /> */}

        <CtART
          rowsdata={this.state.rows}
          columnsdata={this.state.columnsdata}
          rowsPerPage={this.state.rowsPerPage}
          tblmaxHeight={500}
          csvFileName={csvFileName("Customer")}
          rowIconAction={[
            {
              label: "Edit",
              onClick: this.handleARDonActionClick_Edit,
              icon: "Edit",
              className: "secondary-button",
            },
            {
              label: "Delete",
              onClick: this.handleARDonActionClick_Delete,
              icon: "delete",
              className: "delete-button",
            },
            // this.props.userPrivilege["Entry:Proposal"] == "M"
            //   ? {
            //       label: "Delete",
            //       onClick: this.handleARDonActionClick_Delete,
            //       icon: "delete",
            //       className: "delete-button",
            //     }
            //   : "",
          ]}
          // tableButtonAction={[
          //   {
          //     label: "Sales Entry",
          //     onClick: this.handleOnNewEntryClick,
          //     addPluseIcon: true,
          //   },
          //   // this.props.userPrivilege["Entry:Proposal"] != "R"
          //   //   ? {
          //   //       label: "Add New Proposal",
          //   //       onClick: this.handleOnNewEntryClick,
          //   //       addPluseIcon: true,
          //   //     }
          //   //   : "",
          // ]}
          showColumnFilters={false}
          actionColSize={90}
          hideColIdList={["bint_srno", "dec_percentageonsalesamount"]}
          density={"compact"}
        />

        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}
export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(ReferenceMaster)));
